import { Check, Wand2 } from 'lucide-react'
import { cn } from '@/lib/utils'
import { ICONS } from '../home/icons'
import { ICON_KEYS, ICON_LABELS, iconFor } from '../home/model'

interface Props {
    value: string
    onChange: (key: string) => void
    /** What "Automatic" would pick, shown on its tile. */
    form: { name: string; slug: string; category: string }
}

/** Choose a form's front-page icon, or leave it automatic. */
export function IconPicker({ value, onChange, form }: Props) {
    const auto = ICONS[iconFor(form)]
    const tiles = [{ key: '', label: 'Automatic', Icon: auto }, ...ICON_KEYS.map((k) => ({ key: k as string, label: ICON_LABELS[k], Icon: ICONS[k] }))]
    return (
        <div role="radiogroup" aria-label="Icon" className="grid grid-cols-4 gap-2 sm:grid-cols-6 lg:grid-cols-8">
            {tiles.map(({ key, label, Icon }) => {
                const selected = value === key
                return (
                    <button key={key || 'auto'} type="button" role="radio" aria-checked={selected} aria-label={label} onClick={() => onChange(key)}
                        className={cn(
                            'relative flex flex-col items-center gap-1.5 rounded-lg border bg-card px-2 py-3 text-xs text-muted-foreground transition-colors hover:bg-muted focus-visible:outline-2 focus-visible:outline-ring',
                            selected && 'border-primary bg-primary/5 text-foreground',
                        )}>
                        <Icon className="size-5" />
                        <span className="truncate">{label}</span>
                        {key === '' && <Wand2 className="absolute right-1.5 top-1.5 size-3 opacity-60" aria-hidden />}
                        {selected && <Check className="absolute left-1.5 top-1.5 size-3 text-primary" aria-hidden />}
                    </button>
                )
            })}
        </div>
    )
}
